import React from 'react';

const SVG = ({
  id = 'connectors',
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Connectors',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-connectors-1 { fill: none; }
          .${id}.svg-fill-connectors { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <rect
          id="Rectangle_758"
          data-name="Rectangle 758"
          className="svg-connectors-1"
          width="25"
          height="25"
        />
        <path
          className={`${id} svg-fill-connectors`}
          d="M22.91,12.35a1.76,1.76,0,0,0-2-1.48,1.75,1.75,0,0,0-1.32,1H18.36a6,6,0,0,0-.91-2.51h2.3a.68.68,0,0,0,.69-.69V6.43a1.76,1.76,0,0,0,1-2A1.74,1.74,0,0,0,19.4,3.11a1.75,1.75,0,0,0-1.12.75,1.75,1.75,0,0,0,.78,2.57V8H16.21a6,6,0,0,0-3-1.29V4.36a1.75,1.75,0,0,0,1-2,1.73,1.73,0,0,0-.75-1.11A1.71,1.71,0,0,0,12.14,1a1.75,1.75,0,0,0-.34,3.32V6.67A6,6,0,0,0,8.73,8H5.91V6.41A1.76,1.76,0,0,0,7,4.47,1.77,1.77,0,0,0,5,3a1.77,1.77,0,0,0-1.45,2,1.77,1.77,0,0,0,1,1.32V8.65a.69.69,0,0,0,.7.69H7.49a6,6,0,0,0-.9,2.5H5.41a1.76,1.76,0,0,0-2-.93,1.76,1.76,0,0,0-1.26,2.14A1.76,1.76,0,0,0,3,14.12a1.75,1.75,0,0,0,2.52-.89H6.59a5.94,5.94,0,0,0,.9,2.5H5.19a.69.69,0,0,0-.69.69v2.16a1.74,1.74,0,0,0-1,2,1.76,1.76,0,0,0,3.2.52,1.72,1.72,0,0,0,.21-1.33,1.75,1.75,0,0,0-1.05-1.22V17.12H8.73A6,6,0,0,0,11.8,18.4v2.24A1.75,1.75,0,0,0,12.49,24a1.34,1.34,0,0,0,.35,0A1.75,1.75,0,0,0,14,23.21a1.75,1.75,0,0,0-.78-2.57V18.4a6,6,0,0,0,3-1.28h2.86v1.45a1.75,1.75,0,0,0-1,2,1.73,1.73,0,0,0,.75,1.11,1.71,1.71,0,0,0,1.32.25,1.75,1.75,0,0,0,.34-3.32V16.43a.68.68,0,0,0-.2-.49.7.7,0,0,0-.49-.2h-2.3l.16-.25a.54.54,0,0,0,0-.1,4.61,4.61,0,0,0,.43-1l0-.08a6.26,6.26,0,0,0,.25-1.14h1.17a1.76,1.76,0,0,0,1.9,1.12,1.76,1.76,0,0,0,1.48-2Zm-1.37.26a.37.37,0,0,1-.37.36.36.36,0,0,1-.37-.36.37.37,0,0,1,.74,0ZM5.61,20.18a.38.38,0,0,1-.37.37.37.37,0,0,1-.37-.37.36.36,0,0,1,.28-.36H5.3A.37.37,0,0,1,5.61,20.18ZM19.38,4.82a.37.37,0,0,1,.37-.37.37.37,0,0,1,0,.74A.37.37,0,0,1,19.38,4.82ZM12.49,2.38a.39.39,0,0,1,.27.11.35.35,0,0,1,.1.26.37.37,0,0,1-.37.37.38.38,0,0,1-.37-.37.38.38,0,0,1,.37-.37Zm-.08,19.51h.16a.36.36,0,0,1,.29.36.38.38,0,0,1-.63.26.37.37,0,0,1,.18-.62Zm3.3-5.75-.23-.22a4.59,4.59,0,0,1-6,0l-.08-.07a4.52,4.52,0,0,1-.26-6.38l.27-.26.12-.11a4.56,4.56,0,0,1,5.88,0,1.08,1.08,0,0,0,.15.14,4.51,4.51,0,0,1,1.26,4.66l-.41.94a4.51,4.51,0,0,1-.9,1.09l.21.24ZM5.64,4.76a.38.38,0,1,1-.76,0,.39.39,0,0,1,.38-.39A.38.38,0,0,1,5.64,4.76ZM4.2,12.61a.37.37,0,1,1-.37-.37A.37.37,0,0,1,4.2,12.61Zm15.18,7.57a.37.37,0,0,1,.37-.37.37.37,0,0,1,0,.74A.37.37,0,0,1,19.38,20.18Z"
        />
        <path
          className={`${id} svg-fill-connectors`}
          d="M12.47,9.4a3.06,3.06,0,1,0,3.06,3.06A3.06,3.06,0,0,0,12.47,9.4Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
